import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'typeOfPipe',
})
export class TypeofPipe implements PipeTransform {

  transform(value: any): any {
    const type =  typeof value;
    if(Object.prototype.toString.call(value) === '[object Array]') {
      return 'array';
    }

    return type;
  }

}
